import { notification } from "antd";
import { useJournalMutation } from "@/entities/journal/fetch/fetch-client";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { extractSignXml } from "@shared/ui";

export const useWithSignedString = () => {
  const { mutateAsync: sendSignedXml } = useJournalMutation(
    "post",
    "/api/v1/journals/section-two/{sectionTwoListId}/items/{itemNoVersionId}/sign/done",
  );

  const withSignedString = async (
    params: {
      sectionOneListId?: string;
      sectionListId?: string;
      itemNoVersionId: string;
      signerEmployeeId: string;
      onSuccess?: () => void;
    },
    signedXml: string,
    mchdId?: string,
  ) => {
    try {
      const signXml = extractSignXml(signedXml);

      await sendSignedXml({
        params: {
          path: {
            sectionTwoListId: params.sectionOneListId || params.sectionListId || "",
            itemNoVersionId: params.itemNoVersionId,
          },
        },
        body: {
          signer: {
            signerEmployeeId: params.signerEmployeeId,
          },
          signXml,
          ...(mchdId ? { mchdId } : {}),
        },
      });

      params.onSuccess?.();
      notification.success({ message: NOTIFICATION_MESSAGES.ENTRY_SIGNED_SUCCESS_ALT }); // "Запись успешно подписана"
    } catch (err: any) {
      notification.error({
        message: NOTIFICATION_MESSAGES.XML_SIGN_SEND_ERROR, // "Ошибка отправки подписи"
        description: err.response?.data?.errorDescription || "Неизвестно",
        placement: "topRight",
      });
    }
  };

  return {
    withSignedString,
  };
};

